/*=========================================================================================
  File Name: moduleScheduleActions.js
  Description: Schedule Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import firebase from "firebase/app";
import axios from "@/axios.js";
import CryptoJS from "crypto-js";
import {v4 as uuidv4} from "uuid";

import followersActions from "./followers/actions";
import * as constants from "@/constants";

export default {
	addEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post("/events/create/v2", event)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventsByResourceId({commit}, payload) {
		if (!Array.isArray(payload.resource_id)) {
			if (payload.resource_id) {
				payload.resource_id = [payload.resource_id];
			}
		}

		if (!payload.event_status_id) {
			payload.event_status_id = [1, 2, 3, 4, 5, 6, 7];
		}

		payload.fields = ["additional_info", "on_demand", "event_init_hour", "event_end_hour", "schedule_follwers_id"];

		return new Promise((resolve, reject) => {
			Api.post("/events/list", payload)
				.then((response) => {
					commit("SET_SCHEDULE_EVENTS", response.data.records);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventsToProgramedRoute({commit}, payload) {
		if (!Array.isArray(payload.resource_id)) {
			payload.resource_id = [payload.resource_id];
		}
		payload.event_status_id = [1, 2, 3, 4, 5, 6, 7];
		return new Promise((resolve, reject) => {
			Api.post("/events/list", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventStatusLabel({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/eventstatus")
				.then((response) => {
					commit("SET_SCHEDULE_LABELS_STATUS", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	editEvent({commit}, events) {
		let eventsUpdate = [];
		if (!Array.isArray(events)) {
			eventsUpdate.push(events);
		} else {
			eventsUpdate = events;
		}
		const payload = {
			events: eventsUpdate,
		};

		return new Promise((resolve, reject) => {
			Api.post(`/events/reschedule`, payload)
				.then((response) => {
					// Organization data for update the store information
					const eventUpdate = eventsUpdate[0];
					delete eventUpdate.date;
					commit("UPDATE_EVENT", eventUpdate);
					commit("CLEAN_SELECTED_EVENTS", []);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	changeStatusEvent({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/changestatus`, payload)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/cancel`, event)
				.then((response) => {
					commit("REMOVE_EVENT", event.events);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	cancelEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/cancel`, event)
				.then((response) => {
					commit("CHENGE_STATUS_EVENT", event.events);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	statisticsEvent({commit}, event) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/statistics`, event)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	eventRoute({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post(`/events/route`, payload)
				.then((response) => {
					// Agregamos propiedad id a los eventos
					const events = response.data.map((event) => ({...event, id: event.event_id}));
					if (events.length > 0) {
						commit("SET_SCHEDULE_EVENTS", events);
					}
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	selectedResource({commit}, resource) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_RESOURCE", resource);
			resolve(resource);
		});
	},
	cleanEvents({commit}) {
		return new Promise((resolve, reject) => {
			try {
				commit("CLEAN_EVENTS");
				resolve([]);
			} catch (error) {
				reject(error);
			}
		});
	},
	fetchEventsOnDemand({commit}, payload) {
		if (!Array.isArray(payload.resource_id)) {
			if (payload.resource_id) {
				payload.resource_id = [payload.resource_id];
			}
		}

		if (!payload.event_status_id) {
			payload.event_status_id = [1, 2, 3, 4, 5, 6, 7];
		}

		payload["fields"] = ["on_demand", "event_init_hour", "event_end_hour"];

		return new Promise((resolve, reject) => {
			Api.post("/events/list", payload)
				.then((response) => {
					resolve(response.data.records);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventById({commit}, payload) {
		payload["fields"] = [
			"on_demand",
			"event_init_hour",
			"event_end_hour",
			"additional_info",
			"schedule_follwers_id",
		];
		return new Promise((resolve, reject) => {
			Api.post("/events/list", payload)
				.then((response) => {
					// save the event in the store cachedEvents
					commit("SET_CACHED_EVENTS", response.data.records);
					resolve(response.data.records);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	/**
	 * Event tracking action. This action is used to track events.
	 * @param {Object} commit - The Vuex commit function.
	 * @param {Object} payload - The payload containing the event data to track. payload = {client_secret, code , event_uuid}
	 * @returns {Promise} - A promise that resolves with the server response.
	 */
	async eventTracking({commit, dispatch}, event_uuid = "") {
		const code = uuidv4();

		const payload = {
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
			code,
			event_uuid,
		};

		try {
			const url = process.env.VUE_APP_API_BASE_URL + "/events/history";
			const response = await axios.post(url, payload, {
				headers: {
					"Content-Type": "application/json",
					Authorization: await dispatch("generateAuthorizationBearer", code),
				},
			});

			return response.data;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async recoveryRandomKey() {
		const randomKeyRef = firebase.database().ref("random_key/WEB");
		const snapshot = await randomKeyRef.once("value", () => {});
		return snapshot.val();
	},

	async generateAuthorizationBearer({commit, dispatch}, code) {
		const now = new Date();
		const year = now.getUTCFullYear();
		const month = now.getUTCMonth() + 1;
		const day = now.getUTCDate();

		const formatNow = `${year}${month > 9 ? month : "0" + month}${day > 9 ? day : "0" + day}`;

		const randomKey = await dispatch("recoveryRandomKey");

		const authorizationBearer = CryptoJS.SHA512(randomKey + formatNow + code).toString();

		return `Bearer ${authorizationBearer.substring(0, 30)}`;
	},

	async createScheduleWaypoint({commit}, payload) {
		try {
			const response = await Api.post("/schedule_waypoint", payload);
			commit("ADD_WAYPOINT", response.data);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async updateScheduleWaypoint({commit}, waypoint) {
		try {
			const response = await Api.put(`/schedule_waypoint/${waypoint.id}`, waypoint.getDataToUpdate());
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async deleteScheduleWaypoint({commit}, payload) {
		try {
			const response = await Api.delete(`/schedule_waypoint/${payload.id}`);
			commit("REMOVE_WAYPOINT", payload.index);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async updateScheduleWaypointsOrder({commit}, payload) {
		try {
			const response = await Api.post(`/schedule_waypoint/order`, payload);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async fetchScheduleWaypoints({commit}, payload) {
		try {
			const response = await Api.post("/schedule_waypoint/filter", {...payload, page: 1});
			commit("SET_WAYPOINTS", response.data.records);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	/**
	 * Fetches the route for the given waypoints and additional parameters.
	 *
	 * @param {Object} context - The Vuex action context.
	 * @param {Function} context.commit - The Vuex commit function.
	 * @param {Object} params - The parameters for the request.
	 * @param {Array} params.waypoints - The waypoints for the route. Each waypoint should have the following properties: {"longitude": -73.93980510626545,"latitude": 4.908625476332968}.
	 * @param {string} params.init_hour - The initial hour for the schedule.
	 * @param {string} params.end_hour - The end hour for the schedule.
	 * @param {Object} params.config - The configuration object.
	 * @param {number} params.config.company_id - The company ID.
	 * @param {string} params.config.profile - The profile.
	 * @param {string} params.config.mesh - The mesh.
	 * @param {number} params.config.max_speed - The maximum speed.
	 * @returns {Promise<Object>} The response from the API or an error object.
	 */
	async fetchWaypointsRoute({commit}, {waypoints, ...rest}) {
		const payload = {
			waypoints,
			...rest,
		};
		try {
			const response = await Api.post("/schedule_waypoint/route", payload);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async rescheduleEvent({commit}, event) {
		const payload = {
			events: [event],
		};

		try {
			const response = await Api.post("/events/reschedule", payload);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async createEvents({commit}, event) {
		try {
			const response = await Api.post("/events/create/v2", event);
			return response;
		} catch (error) {
			console.error(error);
			return error;
		}
	},

	async fetchScheduleMapStaticImageRequests({commit}, payload) {
		return new Promise((resolve, reject) => {
			Anuket.staticMap(payload.cy, payload.cx, {
				key: process.env.VUE_APP_HERE_MAP_API_KEY,
				size: "600x400",
				callback: (response) => {
					if (response.imageBlob) {
						commit("SET_SCHEDULE_MAP_STATIC_IMAGE_REQUESTS", {
							visitPointId: payload.visitPointId,
							staticMapImage: response.imageBlob,
						});
						resolve(response);
					} else {
						reject(new Error("Failed to fetch static map image"));
					}
				},
			});
		});
	},

	// add followers actions

	...followersActions,
};
